import React, { Component } from 'react';
import { Row, Col, Badge, Form, Card, Input, Button, UncontrolledTooltip } from 'reactstrap';
import { getAPI, putAPI } from '../../Base/API';
import { ActiveInactiveStatusCombo, StyledCard } from '../../Base/Common/CommonUIComponents';
import { FormattedMessage, injectIntl } from "react-intl";
import Authorization from '../../Base/Authorization';
import sendGrid from '../../../img/SendGrid.ico';
import { handleNotification } from '../../Base/Common/Notification';
import ConnectionModal from './ConnectionModal';
import stripo from '../../../img/Stripo.png';
import googleWallet from '../../../img/googleWallet.ico';
import appleWallet from '../../../img/appleWallet.png';


class HotelGroupConnections extends Component {
    static displayName = HotelGroupConnections.name;
    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            bloack: false,
            modal: false,
            connections: [
                {
                    type: 'SendGrid',
                    logo: sendGrid,
                    configuration: { name: null, active: null, type: 'SendGrid', isConfigured: false },
                    title: <FormattedMessage id="HotelConfig.SendGridConnection" />
                },
                {
                    type: 'StripoSharedAccount',
                    logo: stripo,
                    configuration: { name: null, active: null, type: 'StripoSharedAccount', isConfigured: false },
                    connectionName: 'StripoSharedAccountConnection',
                    title: <FormattedMessage id="HotelConfig.StripoConnection" />
                },
                {
                    type: 'GoogleWallet',
                    logo: googleWallet,
                    configuration: { name: null, active: null, type: 'GoogleWallet', isConfigured: false },
                    connectionName: 'GoogleWallet',
                    title: <FormattedMessage id="HotelConfig.GoogleWallet" />
                },
                {
                    type: 'AppleWallet',
                    logo: appleWallet,
                    configuration: { name: null, active: null, type: 'AppleWallet', isConfigured: false },
                    connectionName: 'AppleWallet',
                    title: <FormattedMessage id="HotelConfig.AppleWallet" />
                },
            ]
        }
    }


    componentDidMount() {
        this.getHotelGroupApiConnections();

        // global.modules é preenchido async no Layout e pode chegar depois deste componente.
        // Como não é state/props, o React não re-renderiza sozinho quando muda.
        // Fazemos polling curto até estar disponível (com limite), e aí forçamos um render.
        if (!global.modules) {
            let attempts = 0;
            this.modulesInterval = window.setInterval(() => {
                attempts++;
                if (global.modules) {
                    window.clearInterval(this.modulesInterval);
                    this.forceUpdate();
                }
                else if (attempts >= 40) { // ~10s
                    window.clearInterval(this.modulesInterval);
                }
            }, 250);
        }
    }

    componentWillUnmount() {
        if (this.modulesInterval) {
            window.clearInterval(this.modulesInterval);
        }
    }

    getHotelGroupApiConnections() {
        this.setState({ block: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.response && data.response.length > 0) {
                    const { connections } = this.state;

                    connections.forEach(connection => {
                        const config = data.response?.find(c => c.type === connection.type);

                        if (config) {
                            connection.configuration = config;
                        }
                    })

                    this.setState({ connections, block: false });
                }
                else this.setState({ block: false });
            }
            else this.setState({ block: false });
        }, `/api/Voucher/Hotel/v1/hotelgroup/apiConnections`);
    }

    saveConnection = (event, type) => {
        event.preventDefault();
        this.setState({ block: true });

        const connections = [...this.state.connections];
        const index = connections.findIndex(conn => conn.type === type);
        const config = connections[index].configuration;


        putAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: "danger" });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                    this.setState({ error: errorMessage, block: false });
                }
                else if (data.response && data.response.length > 0) {
                    handleNotification(data, <FormattedMessage id="HotelConfig.ConnectionSaved" />, <FormattedMessage id="generic.success" />);

                    Object.assign(config, data.response[0]);
                    config.isConfigured = true;
                    this.setState({ error: errorMessage, connections: connections, block: false })
                }
            }
            else this.setState({ error: errorMessage, block: false });
        }, '/api/Voucher/Hotel/v1/hotelGroup/apiConnection', JSON.stringify({ request: config }));
    }

    toggleModal = (configuration) => {
        this.setState(prevState => ({
            modal: !prevState.modal,
            selectedConfig: configuration
        }))
    }

    handleChange = (e, type) => {
        const { name, value } = e.target;
        const { connections } = this.state;
        const index = connections.findIndex(conn => conn.type === type);

        if (index !== -1) {
            if (!connections[index].configuration) {
                connections[index].configuration = { type, isConfigured: false };
            }
            connections[index].configuration[name] = value;
        }

        this.setState({ connections })
    }

    handleConnectionStatus = (type, fieldName, combo) => {
        const { connections } = this.state;
        const index = connections.findIndex(conn => conn.type === type);

        if (index !== -1) {
            if (!connections[index].configuration) {
                connections[index].configuration = { type, isConfigured: false };
            }
            connections[index].configuration.active = combo ? combo.value : null;
        }

        this.setState({ connections })
    };

    // Renders the icon + tooltip + Authorization wrapper shared by the action buttons.
    renderActionButton = ({ perform, id, icon, tooltipId, onClick }) => (
        <Authorization
            perform={perform}
            yes={() => (
                <>
                    <Button className="btn btn-sm btn-host mr-2" onClick={onClick} id={id}>
                        <i className={icon} />
                    </Button>
                    <UncontrolledTooltip placement="bottom" target={id}>
                        <FormattedMessage id={tooltipId} />
                    </UncontrolledTooltip>
                </>
            )}
            no={() => <div></div>}
        />
    );


    render() {
        const { connections } = this.state;


        return (
            <StyledCard icon={'fa-solid fa-link'} title={'HotelConfig.Connections'} error={this.state.error} block={this.state.block}>

                {connections.map((connection, key) => global.modules && global.modules.some(m => m === connection.type) ?
                    <Form onSubmit={(e) => this.saveConnection(e, connection.type)} key={key}>
                        <Row className="align-items-center mb-1 py-3 overbglight">
                            <Col>
                                <h5 className="m-0">
                                    <img alt="" src={connection.logo} height="20px" className="mr-2" />
                                    {connection.title}
                                </h5>
                            </Col>

                            <Col className="col-1"><FormattedMessage id="HotelConfig.Name" /></Col>
                            <Col className="col-3 pl-0">
                                <Input
                                    maxLength="200"
                                    name="name"
                                    value={connection.configuration && connection.configuration.name || ''}
                                    onChange={(e) => this.handleChange(e, connection.type)}
                                    required
                                />
                            </Col>
                            <Col className="col-1"><FormattedMessage id="generic.status" /></Col>
                            <Col className="col-2 pl-0">
                                <ActiveInactiveStatusCombo
                                    name='active'
                                    onChangeFunc={this.handleConnectionStatus.bind(this, connection.type)}
                                    placeholder={''}
                                    value={connection.configuration && connection.configuration.active}
                                    required
                                />
                            </Col>

                            <Col className="d-flex justify-content-end" sm={2}>
                                {connection.type === 'GoogleWallet' ?
                                    this.renderActionButton({
                                        perform: "hotelConfig:connection:test",
                                        id: `CheckAccount${key}`,
                                        icon: "fas fa-eye",
                                        tooltipId: "HotelConfig.CheckAccount",
                                        onClick: () => this.toggleModal(connection.configuration, false)
                                    })
                                    : ''}

                                {connection.type !== 'GoogleWallet' && connection.type !== 'AppleWallet' && connection.configuration && (connection.configuration.isConfigured === undefined || connection.configuration.isConfigured !== false) ?
                                    this.renderActionButton({
                                        perform: "hotelConfig:connection:newKey",
                                        id: `setNewKey${key}`,
                                        icon: "fa-solid fa-key",
                                        tooltipId: "HotelConfig.SetNewKey",
                                        onClick: () => this.toggleModal(connection.configuration)
                                    })
                                    : ''}


                                <Authorization
                                    perform="hotelConfig:connection:save"
                                    yes={() => (
                                        <Button className="btn btn-sm  btn-host " type="submit">
                                            <i className="fa-solid fa-floppy-disk "></i>
                                        </Button>
                                    )}
                                    no={() => <div></div>}
                                />
                            </Col>
                        </Row>
                    </Form>
                    : '')}


                {this.state.modal ?
                    <ConnectionModal
                        modal={this.state.modal}
                        toggleModal={this.toggleModal}
                        selectedConfig={this.state.selectedConfig}
                    />
                : ''}
            </StyledCard>
        );
    }
}

export default injectIntl(HotelGroupConnections);
